const awsConfig = {
    Auth: {
        region: 'us-east-1',
        // userPoolId: 'us-east-1_K2XbxQ2bT',
        // userPoolWebClientId: '5nud0gq4v734gjakbbvsev6juq',
        // identityPoolId: 'us-east-1:19500374-dc83-4c10-87c7-78bc565c08f6',
        
        //PRODUCCIÓN
        userPoolId: 'us-east-1_knEOiun6x',
        userPoolWebClientId: '2pko95qpgb7omiv92nnabo5012',
        identityPoolId: 'us-east-1:d1846315-6ad6-4d1b-a310-cf61824aed22',

        // PRUEBAS
        // userPoolId: 'us-east-1_68nQbFvhN',
        // userPoolWebClientId: '76f12o9hcs03mm5ab7l272gsu2',
        // identityPoolId: 'us-east-1:fef6eb71-e47f-4858-a13e-f6fc58c86882',

        //CALIDAD
        // userPoolId: 'us-east-1_1T60aIB8G',
        // userPoolWebClientId: 'apfrtga9lp5tulpumidnn39vt',
        // identityPoolId: 'us-east-1:d1f8510d-90c7-4037-b497-4a2d57f3573e',

    },
    API: {
        endpoints: [
            {
                name: 'Ransa360API',
                // endpoint: 'https://q9hpg27one.execute-api.us-east-1.amazonaws.com/dev',
                // endpoint: 'https://api-r360-tmp.sbx.ransaaplicaciones.com',
                // endpoint: 'https://api-r360-configuracion.sbx.ransaaplicaciones.com',
                // endpoint: 'https://api-r360-sbx.sbx.ransaaplicaciones.com', //SBX;
                endpoint: 'https://api-r360.ransaaplicaciones.com', //PRD
                // endpoint: 'https://api-r360.qas.ransaaplicaciones.com', //QAS
            },
        ],
    },
};
export { awsConfig };
